import React from 'react';

import classNames from 'classnames/bind';

export default function TextButton({ children, className, variant, as, customWidth, customHeight, ...props }) {
    const textButtonClass = classNames(className, 'txt-button', {
        primary: variant === 'primary',
        secondary: variant === 'secondary',
        danger: variant === 'danger',
        success: variant === 'success',
    });

    const Tag = as || 'button';

    return (
        <Tag {...props} type="button" className={textButtonClass}>
            <div className={`tw-inline-flex tw-items-center tw-justify-center tw-gap-x-1.5 customWidth ${customWidth ?? ''} ${customHeight ?? ''}`}>
                {children}
            </div>
        </Tag>
    );
}
